import React from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

/* Documentation
https://www.npmjs.com/package/react-image-gallery
*/

/*
Create a carouselbanner with items as parameters
*/
export const CarouselGallery = ({ data }) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Gallery</h2>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {data ? (
              <ImageGallery thumbnailPosition="bottom" items={data} />
            ) : (
              "Loading..."
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
